import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import {PopUpContext} from "../../contexts/popUpContext";

class StudentDocumentsInfoForm extends Form {
    static contextType = PopUpContext;

    state = {
        drp: {},
        data: {
            tazkera_file: "",
            transcript_file: "",
            bank_receipt_ref_no: "",
            passport_file: "",
            certificate_file: "",
        },
        errors: {},
    };

    componentDidMount = async () => {
        const {drp, data} = this.state;
        const {
            popUp: {cache, edit},
        } = this.context;

        if(edit){
            data.bank_receipt_ref_no = edit.bank_receipt_ref_no;
        }

        await db
            .getAll(`dropdowns/cities`)
            .then(({data: {data}}) => (drp["city"] = data));

        await db
            .getAll(`dropdowns/studentSupporters`)
            .then(({data: {data}}) => (drp["supporter"] = data));

        this.setState({drp, data});
    };

    schema = {
        bank_receipt_ref_no: Joi.string().allow(null).allow(''),
        tazkera_file: Joi.string().allow(null).allow(''),
        transcript_file: Joi.string().allow(null).allow(''),
        passport_file: Joi.string().allow(null).allow(''),
        certificate_file: Joi.string().allow(null).allow(''),
    };

    doSubmit = async (e) => {
        const {togglePopUp, popUp} = this.context;
        const student_id = popUp.student.student_id;

        let __controls = this.cleanObject({
            student_id: popUp?.cache,
            ...this.state.data,
        });

        try {
            await db
                .form(`students/${student_id}/info`, e.target, __controls, popUp?.edit?.id)
                .then(() => {
                    togglePopUp({form: "toast"});
                })
                .catch((e) => {
                    togglePopUp({
                        form: "toast",
                        message: e.toString(),
                        type: "warning",
                    });
                });

            if (popUp.callback) popUp.callback();
        } catch ({response}) {
            if (response && response.status === 400) {
                const errors = {...this.state.error};

                this.setState({errors});
            }
        }
    };

    render() {
        const {data, drp} = this.state;
        const {popUp} = this.context;

        return (
            <div className="form-container">
                <form className="form crud" onSubmit={this.handleSubmit}>
                    <div className="head">
                        <p>{popUp?.edit ? lbl.EditStudentDocumentsInfo : lbl.AddStudentDocumentsInfo}</p>
                    </div>
                    <div className="form-inputs">
                        {this.renderInput("bank_receipt_ref_no", "کد رسید فیس داخله")}
                        {this.renderFile("tazkera_file", "تذکره")}
                        {this.renderFile("transcript_file", "نمرات سه ساله")}
                        {this.renderFile("passport_file", "پاسپورت")}
                        {this.renderFile("certificate_file", "شهادت نامه")}
                    </div>
                    <div className="form-buttons">
                        {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
                    </div>
                </form>
            </div>
        );
    }
}

export default StudentDocumentsInfoForm;
